import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';
import CatalogoCatProgramatica from '../../catalogos/catalogoCategoriaProgramatica';

export const ImprimirEjGastoPartCuentSubCat = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [parameter, setParameter] = useState("");
    const [condi, setCondi] = useState('');
    const [report, setReport] = useState('');
    const [mostrar4, setMostrar4] = useState(false);
    const [desde, setDesde] = useState('');
    const [hasta, setHasta] = useState('');
    const [val, setVal] = useState(0);
    const [val2, setVal2] = useState(0);
    const [cata, setCata] = useState(0);
    const [gen, setGen] = useState(0);
    const [valor1, setValor1] = useState('00');
    const [valor2, setValor2] = useState('00');
    const [valor3, setValor3] = useState('00');
    const [valor4, setValor4] = useState('00');
    const [valor5, setValor5] = useState('00');
    const [valor6, setValor6] = useState('0000');
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtDesde = useRef();
    const txtHasta = useRef();
    const txtChk1 = useRef();
    const txtChk2 = useRef();
    const txtChk3 = useRef();
    const txtCheck = useRef();
    const txtChkd1 = useRef();
    const txtChkd2 = useRef();

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtDesde.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione la Fecha!', icono: 'informacion' });
            sigue = false;
            txtDesde.current.focus();
        }

        else if (sigue) {
            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Desea abrir el reporte en formato PDF?', icono: 'confirmacion' });
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'desde') {
            setDesde(e.target.value);
        } else if (e.target.id === 'hasta') {
            setHasta(e.target.value);
        }
        onCheck();
    };

    const onCheck = () => {

        var val = 0;
        if (txtChk1.current.checked) {
            setCata(1);
            setGen(1);
            setActivo(true);
            setDeshabilitado(false);
            val = 1;
            console.log(parseInt(txtDesde.current.value.substring(5, 7)));
            if (parseInt(txtDesde.current.value.substring(5, 7)) === 1) {
                setReport('Pres_CAT_EjecucionGtMns_SE_a');
            } else {
                setReport('Pres_CAT_EjecucionGtMns_SE_c');
            }
            setCondi("TRUE");
        } else if (txtChk2.current.checked) {
            setCata(0);
            setGen(1);
            setActivo(true);
            setDeshabilitado(true);
            val = 0;
            if (parseInt(txtDesde.current.value.substring(5, 7)) === 1) {
                setReport('Pres_CAT_EjecucionGtMns_SE_a');
            } else {
                setReport('Pres_CAT_EjecucionGtMns_SE_c');
            }
            setParameter("Categoria >= '0' ");

            if (txtCheck.current && txtCheck.current.checked) {
                setCondi("alcaldia = true");
            } else {
                setCondi("TRUE");
            }

        } else if (txtChk3.current.checked) {
            setCata(0);
            setGen(0);
            setActivo(false);
            setDeshabilitado(true);
            if (parseInt(txtDesde.current.value.substring(5, 7)) === 1) {
                setReport('Pres_SE_EjecucionGtosMes01b');
            } else {
                setReport('Pres_SE_EjecucionGtosMes03');
            }
            setParameter("");

            if (txtCheck.current && txtCheck.current.checked) {
                setCondi("alcaldia = true");
            } else {
                setCondi("TRUE");
            }

        }

        if (val !== 1) {
            if (txtChkd1.current && txtChkd1.current.checked) {
                setActivo(false);
                setVal(1);
            } else if (txtChkd2.current && txtChkd2.current.checked) {
                setActivo(false);
                setVal(2);
            }
        } else {
            setActivo(true);
            if (txtChkd1.current && txtChkd1.current.checked) {
                setActivo(false);
                setVal(1);
            } else if (txtChkd2.current && txtChkd2.current.checked) {
                setActivo(false);
                setVal(2);
            }
        }


    }

    const imprimirGeneral = (desde, hasta, cata, reporte, pdf) => {

        let desdec = moment.utc(desde).format('DD-MM-YYYY');
        let hastac = moment.utc(hasta).format('DD-MM-YYYY');
        var parametro = "";
        if (cata === 1) {
            parametro = "Categoria = '" + parameter + "'";
        } else {
            parametro = parameter;
        }
        if (pdf === true) {
            window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&sql1=" + idefiscal + "&sql2=" + condi + "&sql3=" + parametro + "&sql4=" + "'" + desdec + "'" + "&sql5=" + hastac + "&sql6=" + val, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        } else {
            window.open(op.reportes + "/contabilidadpresupuestaria/crearxls?" + "reporte=" + reporte + "&sql1=" + idefiscal + "&sql2=" + condi + "&sql3=" + parametro + "&sql4=" + "'" + desdec + "'" + "&sql5=" + hastac + "&sql6=" + val + "&tipo=excel", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
        }
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        txtDesde.current.value = '';
        txtHasta.current.value = '';
        setActivo(true);
        setMostrar4(false);
        setDesde('');
        setHasta('');
        setCata(0);
        setGen(0);
        setDeshabilitado(false);
        setVal(0);
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        imprimirGeneral(desde, hasta, cata, report, true);

    };

    const handleCloseNo = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        //var report = 'Pres_SE_EjecucionGtosMes01';
        imprimirGeneral(desde, hasta, cata, report, false);

    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const handleCancelaras = () => {
        setMostrar4(false);
    }

    const handleAceptaClasPresupuestaria = (idcategoriaprogramatica, descripcion, categoriaprogramatica) => {
        setMostrar4(false);
        console.log(categoriaprogramatica);
        setValor1(categoriaprogramatica.substring(0, 2));
        setValor2(categoriaprogramatica.substring(2, 4));
        setValor3(categoriaprogramatica.substring(4, 6));
        setValor4(categoriaprogramatica.substring(6, 8));
        setValor5(categoriaprogramatica.substring(8, 10));
        setActivo(false);
        setParameter(categoriaprogramatica);
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                let fech = moment.utc(fechaSistema).format('YYYY-MM-DD');
                txtDesde.current.value = fech;
                txtHasta.current.value = fech;
                setDesde(fech);
                setHasta(fech);

            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Imprimir Nivel SubEspecificas/Cat.Programatica'}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
                <CatalogoCatProgramatica
                    show={mostrar4}
                    onHideCancelar={handleCancelaras}
                    onHideAceptaCatProgramatica={handleAceptaClasPresupuestaria}
                />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                                <legend className="float-none m-0 w-auto" >Datos</legend>

                                <div className='row m-0 px-0 mb-2'>

                                    <div className='col-sm-3 mb-1 px-0'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Desde:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtDesde} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="desde" />
                                        </div>
                                    </div>

                                    <div className='col-sm-1 mb-1 px-0'></div>

                                    <div className='col-sm-3 mb-1 px-0'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Hasta:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtHasta} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="hasta" />
                                        </div>
                                    </div>

                                    <div className='col-sm-3 mb-1 border-azul rounded py-1 ml-auto'>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" ref={txtCheck} onChange={onCheck} type="checkbox" id="inlineCheckbox1" value="option1" />
                                            <label className="form-check-label" for="inlineCheckbox1">Solo Alcaldía</label>
                                        </div>
                                    </div>

                                </div>

                                <div className='row m-0 px-2 col-md-12 mx-auto mb-2 border-azul rounded'>
                                    <div className="form-check col-md-4 ml-auto py-1 mb-2">
                                        <input className="form-check-input" ref={txtChk1} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label" for="flexRadioDefault1">
                                            Seleccionar Categoria
                                        </label>
                                    </div>
                                    <div className="form-check col-md-4 ml-auto py-1 mb-2">
                                        <input className="form-check-input" ref={txtChk2} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label" for="flexRadioDefault2">
                                            Todas las Categorias
                                        </label>
                                    </div>
                                    <div className="form-check col-md-2 ml-auto py-1 mb-2">
                                        <input className="form-check-input" ref={txtChk3} onChange={onCheck} type="radio" name="flexRadioDefault" id="flexRadioDefault3" />
                                        <label className="form-check-label" for="flexRadioDefault3">
                                            General
                                        </label>
                                    </div>

                                </div>

                                {gen !== 0 ? <div className='row m-0 px-2 col-md-12 mx-auto mb-2 border-azul rounded'>
                                    <div className="form-check col-md-4 ml-auto py-2 mb-1">
                                        <input className="form-check-input" ref={txtChkd1} onChange={onCheck} type="radio" name="radiodos" id="radiodos1" />
                                        <label className="form-check-label" for="radiodos1">
                                            Mostrar Deuda
                                        </label>
                                    </div>
                                    <div className="form-check col-md-6 ml-auto py-2 mb-1">
                                        <input className="form-check-input" ref={txtChkd2} onChange={onCheck} type="radio" name="radiodos" id="radiodos2" />
                                        <label className="form-check-label" for="radiodos2">
                                            Mostar Disponibilidad Financiera
                                        </label>
                                    </div>
                                </div> : ''}


                                {cata !== 0 ? <div className='col-md-12 m-0 px-0'>
                                    <table className="table">
                                        <thead>
                                            <tr className='text-center'>
                                                <th scope="col">Sector</th>

                                                <th scope="col">Prog</th>

                                                <th scope="col">SubProg</th>

                                                <th scope="col">Proyec</th>

                                                <th scope="col">Actv</th>

                                                <th scope="col">Auxiliar</th>
                                            </tr>
                                        </thead>
                                        <tbody className='table-bordered'>
                                            <tr className='text-center'>
                                                <td>{valor1}</td>

                                                <td>{valor2}</td>

                                                <td>{valor3}</td>

                                                <td>{valor4}</td>

                                                <td>{valor5}</td>

                                                <td>{valor6}</td>

                                                <td><button onClick={catalogoClass} className="btn btn-sm  btn-info ml-2" ><i className="fa fa-search"></i> </button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> : ''}



                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={handleCloseNo} onHideSi={handleCloseSi} />
        </Modal>

    );
}